<script setup>
/*
 * Opret en prisalarm paa varen.
 *
 * Fører til produktsiden hvor alarmen faktisk oprettes, frem for at
 * bygge en anden formular der skal holdes ved lige to steder.
 */
import { computed } from 'vue';
import { Link } from '@inertiajs/vue3';

const props = defineProps({ data: { type: Object, required: true } });

const pris = computed(() => {
    const n = Number(props.data.vare?.pris);
    if (isNaN(n)) return null;
    return new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK', maximumFractionDigits: 0 }).format(n);
});
</script>

<template>
    <p v-if="!data.vare" class="text-secondary small mb-0">Ingen vare valgt.</p>

    <div v-else class="alarm">
        <div>
            <p class="mb-1 fw-semibold">{{ data.opfordring }}</p>
            <p class="small text-secondary mb-0">
                {{ data.vare.navn }}<span v-if="pris"> — lige nu {{ pris }}</span>
            </p>
        </div>
        <Link :href="`/produkt/${data.vare.slug}`" class="btn btn-sm btn-primary text-nowrap">
            Opret prisalarm
        </Link>
    </div>
</template>

<style scoped>
.alarm {
    display: flex; flex-wrap: wrap; gap: 1rem;
    align-items: center; justify-content: space-between;
    border: 1px solid var(--pc-border); border-radius: var(--pc-radius); padding: 1rem 1.25rem;
}
</style>
